import { render, staticRenderFns } from "./tm-settings-page.vue?vue&type=template&id=7e3b6bc0&scoped=true&"
import script from "./tm-settings-page.vue?vue&type=script&lang=ts&"
export * from "./tm-settings-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-settings-page.vue?vue&type=style&index=0&id=7e3b6bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3b6bc0",
  null
  
)

export default component.exports